/**
 * Наблюдения за прогоном стадии.
 *
 * Счёт и сложение метрик — общая арифметика набора, она живёт в
 * `typing-engine`. Здесь остаётся правило режима: прогон стадии существует
 * ради одного слова, поэтому его результат целиком относится к этому слову —
 * в том числе на стадии «применить», где набирается предложение.
 */

import type { KeystrokeEvent, TypingError } from '@type2x/shared-contracts';
import { observeRun } from '@type2x/typing-engine';

import type { StageObservation } from '../contracts/mistakes.js';

export { EMPTY_OBSERVATION, mergeMetrics, mergeObservations } from '@type2x/typing-engine';

/** Собирает наблюдение по прогону одной стадии. */
export function observeStage(
  word: string,
  events: readonly KeystrokeEvent[],
  errors: readonly TypingError[],
): StageObservation {
  return observeRun([...word].length, events, errors);
}
